const accessibilityRoleToWebRole = {
  adjustable: "slider",
  button: "button",
  header: "heading",
  image: "img",
  imagebutton: null,
  keyboardkey: null,
  label: null,
  link: "link",
  none: "presentation",
  search: "search",
  summary: "region",
  text: null
};
const propsToAriaRole = ({ accessibilityRole }) => {
  if (accessibilityRole) {
    const inferredRole = accessibilityRoleToWebRole[accessibilityRole];
    if (inferredRole !== null) {
      return inferredRole || accessibilityRole;
    }
  }
};
var propsToAriaRole_default = propsToAriaRole;
export {
  propsToAriaRole_default as default
};
//# sourceMappingURL=propsToAriaRole.js.map
